module.exports = __webpack_public_path__ + "static/media/base.ec241fa8.mp4";